import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VisaDesignerService } from '../visa-designer.service';
import * as RolesRouteMap from '../../../data/constants/roles';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-vd-builder-review',
  templateUrl: './vd-builder-review.component.html',
  styleUrls: ['./vd-builder-review.component.scss']
})
export class VdBuilderReviewComponent implements OnInit, AfterViewInit {
  observableSubscription$ = new Subject();
  visaId = 0;
  visaObj = null;
  taskJson = null
  stepsJson = null;
  addForm = new FormGroup({});
  publishedOn = '';
  isEditVisa:boolean = false;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vdService: VisaDesignerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.route.queryParams
    .pipe(takeUntil(this.observableSubscription$)).
    subscribe((params) => {
      this.visaId = params['id'] || null;      
    });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }
  getVisaDetails(){
    this.vdService.getVisaById(this.visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.visaObj =response?.data || null;
      this.publishedOn = this.visaObj?.publishedOn || '';
      this.taskJson = (response?.data?.taskJson) ? JSON.parse(response.data.taskJson) : null;
      this.stepsJson = (response?.data?.stepJson) ? JSON.parse(response.data.stepJson) : null;
      //this.visaObj.stepJson = (response?.data?.stepJson) ? JSON.parse(response.data.stepJson) : null;     
    });
  }
  ngAfterViewInit(){
    if (this.visaId) {
      this.getVisaDetails();
    }
  }
  hadleCancel(){
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/visa-designer/manage-visa/`]);   
  }
  publish(){
    const isRepublishVisa = this.visaObj?.previousTaskTypeId ? true : false;
    this.vdService.publishVisa(this.visaId,isRepublishVisa).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if(response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/visa-designer/manage-visa/`]);   
      }
    });
  }

  // rePublish(){
  //   this.vdService.publishVisa(this.visaId,).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
  //     if(response && response.status === 200) {
  //       this.toastr.success(response.message);
  //       this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/visa-designer/manage-visa/`]);   
  //     }
  //   });
  // }
  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
